module.exports = __webpack_public_path__ + "static/maryon_maass1-284c7f0185bc7d814095355a217ae1ab.jpg";